// @flow
import React from 'react'
import './styles.scss'
import renderHTML from 'react-render-html'
import { Link } from '@ta-interaktiv/contentbricks'

export class Gas extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className='gas-wrapper'>
        <h3>{this.props.name}</h3>
        <div className='text'>
          <div className='facts'>
            {this.props.potential && (
              <div>
                <strong>Treibhausgaspotenzial: </strong>
                {renderHTML(this.props.potential)}
              </div>
            )}
            <div>
              <strong>Emissionsquellen:</strong> {this.props.sources}
            </div>
          </div>
          <img className='formula' src={this.props.formula} />
          {this.props.text}
        </div>
      </div>
    )
  }
}
